export default "__VITE_ASSET__BSma8451__"